import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { channelAcknowledgementFragment } from 'remote/activityRegistry'
import { channelBaseFragment } from 'remote/channels'

import { dataFetched, makesQueries } from 'data/graphql'
import { selectors as OrganizationsSelectors } from 'data/organizations'
import {
  viewIsLoading,
  viewFailedToLoad,
  viewHasLoaded,
  injectViewStateAsMeta,
} from 'data/ui/viewState'

import { createConnectionWarningToasterMessage } from 'data/ui/actions'

const channelAttrsFragment = gql`
  fragment channelListAttrs on Channel {
    ...channelBaseAttrs
    activityAcknowledgement {
      ...channelAcknowledgementAttrs
    }
  }
  ${channelBaseFragment}
  ${channelAcknowledgementFragment}
`

const channelsQuery = gql`
  query showUserChannels {
    me {
      __typename
      id
      channels {
        ...channelListAttrs
      }
    }
  }
  ${channelAcknowledgementFragment}
  ${channelAttrsFragment}
`

export const syncsChannels = viewName =>
  compose(
    connect(
      state => ({
        organizationId: OrganizationsSelectors.getOrganizationId(state),
      }),
      {
        dataFetched,
        viewIsLoading,
        viewFailedToLoad,
        createConnectionWarningToasterMessage,
        injectViewStateAsMeta,
      }
    ),
    makesQueries({
      query: channelsQuery,
      resyncPolicy: 'refetch',
      mapPropsToVariables: ({ organizationId }) => ({ organizationId }),
      getOnQueryFromProps: ({ viewIsLoading }) => () =>
        viewIsLoading(viewName, 'loadChannelsList'),
      getOnResultFromProps: ({ injectViewStateAsMeta }) => ({
        result,
        meta,
      }) => {
        injectViewStateAsMeta(
          dataFetched(result.data.me.channels, meta),
          viewHasLoaded(viewName, 'loadChannelsList')
        )
      },
      getOnErrorFromProps: ({
        viewFailedToLoad,
        createConnectionWarningToasterMessage,
      }) => ({ error, meta }) => {
        if (meta.isRefresh) {
          createConnectionWarningToasterMessage()
        } else {
          return viewFailedToLoad(viewName, 'loadChannelsList', error)
        }
      },
    })
  )
export default syncsChannels
